import { AnalyticsContextType } from "@/Contexts/AnalyticsContext";
import {
    CookieManagerContext,
    CookieSettings,
    initialCookieContext,
} from "@/Contexts/CookieManagerContext";
import { getCookie, setCookie } from "@/utils/CookieJar";
import { router } from "@/utils/turboSafeInertia";
import { PropsWithChildren, useEffect, useState } from "react";

export function CookieManagementProvider({ children }: PropsWithChildren) {
    const [cookieSettings, setCookieSettings] = useState(
        initialCookieContext.cookieSettings,
    );
    const [showCookieSettingsModal, setShowCookieSettingsModal] = useState(
        initialCookieContext.showCookieSettingsModal,
    );
    const [showCookieBanner, setShowCookieBanner] = useState(
        initialCookieContext.showCookieBanner,
    );
    const [hasEverBeenSaved, setHasEverBeenSaved] = useState(
        initialCookieContext.hasEverBeenSaved,
    );
    const [analyticsSettingToggleState, setAnalyticsToggleState] = useState(
        initialCookieContext.cookieSettings.analytics,
    );
    const [advertisingSettingToggleState, setAdvertisingToggleState] = useState(
        initialCookieContext.cookieSettings.advertising,
    );

    const persistToServer = (cookieSettings: CookieSettings) => {
        router.post(route("cookie-settings"), {
            analytics: cookieSettings.analytics,
            advertising: cookieSettings.advertising,
        });
    };

    const saveCookieSettingsAndCloseAll = (
        cookieSettings: CookieSettings,
        analytics: AnalyticsContextType,
    ) => {
        analytics.trackEvent("saved_cookies", {
            analytics_cookie: cookieSettings.analytics,
            advertising_cookie: cookieSettings.advertising,
        });
        dataLayer.push({
            event: "saved_cookies",
            analytics_cookie: cookieSettings.analytics,
            advertising_cookie: cookieSettings.advertising,
        });
        setCookieSettings(cookieSettings);
        setCookie("cookie-settings", cookieSettings);
        setShowCookieSettingsModal(false);
        setShowCookieBanner(false);
        persistToServer(cookieSettings);
        setCookie("hasEverBeenSaved", true);
        setHasEverBeenSaved(true);
    };

    const resetCookieSettingsToLastSaved = () => {
        setAnalyticsToggleState(cookieSettings.analytics);
        setAdvertisingToggleState(cookieSettings.advertising);
    };

    useEffect(() => {
        if (getCookie("cookie-settings", null) !== null) return;
        setCookie("cookie-settings", {
            analytics: true,
            advertising: false,
        });
    }, []);

    return (
        <CookieManagerContext.Provider
            value={{
                showCookieSettingsModal,
                showCookieBanner,
                cookieSettings,
                resetCookieSettingsToLastSaved,
                saveCookieSettingsAndCloseAll,
                setShowCookieSettingsModal,
                setShowCookieBanner,
                hasEverBeenSaved,
                analyticsSettingToggleState,
                advertisingSettingToggleState,
                setAnalyticsToggleState,
                setAdvertisingToggleState,
            }}
        >
            {children}
        </CookieManagerContext.Provider>
    );
}
